import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

@Component
export default class TelstraUIVueSvg extends Vue {
  @Prop() className!: string;
  @Prop({ required: true }) name!: string;

  icons = require('../../../telstra-ui-resources/images/sprite.symbol.svg');

  @Emit()
  click(event: any) {
    this.$emit('click', event);
  }
}
